import { FC, ReactNode } from 'react'
import { ThemeProvider as Provider } from 'styled-components'
import { theme } from '.'

type Props = {
  children: ReactNode
}

const ThemeProvider: FC<Props> = ({ children }) => {
  return <Provider theme={theme}>{children}</Provider>
}

export default ThemeProvider
